import { render, staticRenderFns } from "./BudgetInbox.vue?vue&type=template&id=652aa403&"
import script from "./BudgetInbox.vue?vue&type=script&lang=js&"
export * from "./BudgetInbox.vue?vue&type=script&lang=js&"
import style0 from "./BudgetInbox.vue?vue&type=style&index=0&id=652aa403&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports